export interface Elevator {
	SerialNumber: string;
	BuildingsID: string;
	ElevatorsID: string;
}

export interface Building {
	BuildingsID: string;
	BuildingName: string;
}

export interface Mechanic {
	Name: string;
	MechanicID: string;
}

interface IntStaticVars {
	Elevators: Array<Elevator>;
	Buildings: Array<Building>;
	Mechanics: Array<Mechanic>;
}

export const StaticVariables: IntStaticVars = {
	Elevators: null as Array<Elevator>,
	Buildings: null as Array<Building>,
	Mechanics: null as Array<Mechanic>,
};

export async function GetBuildings() {
	if (StaticVariables.Buildings !== null) return;
	let dt = await fetch("Building");
	dt = await dt.json();

	StaticVariables.Buildings = (dt as any).map((x: any) => {
		return {
			BuildingName: x.building_name,
			BuildingsID: x.buildings_id,
		} as Building;
	});
}

export async function GetElevators() {
	if (StaticVariables.Elevators !== null) return;
	let dt = await fetch("Building/GetAllElevators", {
		method: "Post",
		cache: "no-cache",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({}),
	});
	dt = await dt.json();

	StaticVariables.Elevators = (dt as any).map((x: any) => {
		return {
			ElevatorsID: x.elevators_id,
			BuildingsID: x.buildings_id,
			SerialNumber: x.serial_number,
		} as Elevator;
	});
}

export async function GetMechanics() {
	if (StaticVariables.Mechanics !== null) return;
	let data = await fetch("User/GetMechanics", {
		method: "POST",
		cache: "no-cache",
		headers: {
			"Content-Type": "application/json",
		},
		body: JSON.stringify({}),
	});

	data = await data.json();

	StaticVariables.Mechanics = (data as any).map((x: any) => {
		return {
			Name: x.full_name,
			MechanicID: x.users_id,
		} as Mechanic;
	});
}
